import React from 'react'

const Hamburger =({isOpen,toggleHeader})=>(
	<div className={isOpen?"hamburger open":"hamburger"} id="hamburger" onClick={toggleHeader}>
		<span></span>
		<span></span>
		<span></span>
	</div>
)
export default Hamburger;


// WEBPACK FOOTER //
// ./src/components/Hamburger.js